// Logo lockup for the GSG advisors and mentors call header.
// GSG is the primary brand (this is an organization-wide open call), with
// Mercy Corps as the partnership byline. Stacks vertically on mobile.

export function LogoLockup() {
  return (
    <div className="flex flex-col items-center gap-4 md:flex-row md:justify-between md:items-center">
      {/* Primary: Gaza Sky Geeks */}
      <img
        src="/logo-2.png"
        alt="Gaza Sky Geeks"
        className="h-9 sm:h-10 md:h-11 w-auto object-contain"
      />

      {/* Partnership byline */}
      <div className="flex items-center gap-3 sm:gap-4 md:gap-5">
        <span className="hidden sm:inline text-[10px] md:text-[11px] uppercase tracking-[0.22em] text-white/55 whitespace-nowrap">
          A Mercy Corps program
        </span>
        <img
          src="/logo-3.png"
          alt="Mercy Corps"
          className="h-6 sm:h-6 md:h-7 w-auto object-contain"
        />
      </div>
    </div>
  );
}

// Tiny version for inside the wizard (after the user clicks Begin).
export function MiniLockup() {
  return (
    <div className="flex items-center gap-3">
      <img src="/logo-2.png" alt="Gaza Sky Geeks" className="h-6 w-auto object-contain" />
      <span className="text-brand-line">·</span>
      <img src="/logo-3.png" alt="Mercy Corps" className="h-5 w-auto object-contain" />
    </div>
  );
}
